import { documentReady } from "../Utility/utils";
import Flickity from "flickity";
import "flickity/dist/flickity.min.css";


const initializeBlock = function( $block ){
  // First, Determine which block we're in, and set the args accordingly.
  let slider;
  let args;

  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // Default Slider Block
  if(!!$block.querySelector('.slider_block__slider')){
    slider = $block.querySelector('.slider_block__slider');
    const prev = $block.querySelector('.prev.slider_block__nav_link');
    const next = $block.querySelector('.next.slider_block__nav_link');
    const progressBar = $block.querySelector('.slider_block__progress');
    let progress;

    const getProgress = (index, slidesCount) => {
      progress = (index / slidesCount * 100);
      return progress;
    }

    const setProgress = (progress) => {
      progress = progress + '%';
      progressBar.style.setProperty('--progress-width', progress);
    }

    const slider_nav_disabled_status = (index, slidesCount) => {

      if(index == 1){
        prev.classList.add('disabled');
      }
      else{
        prev.classList.remove('disabled');
      }
      if(index == slidesCount){
        next.classList.add('disabled');
      }
      else {
        next.classList.remove('disabled');
      }
    }

    var flkty = new Flickity( slider, {
      prevNextButtons: false,
      pageDots: false,
      on: {
        ready: function() {
          progress = getProgress(1, this.slides.length);
          setProgress(progress);
          slider_nav_disabled_status(1, this.slides.length);
        },
        change: function( index ) {
          progress = getProgress(index + 1, this.slides.length);
          setProgress(progress);
          slider_nav_disabled_status(index + 1, this.slides.length);
        }
      }
    });

    // sometimes the slider is initialized before the images have been fully loaded,
    // causing the slider to take a less than full height. Let's ensure it is expanded
    setTimeout(function(){
      flkty.resize();
    }, 1000);

    // Slider Nav
    if(!!prev && !!next){
      prev.addEventListener('click', (e) => {
        prev.blur();
        flkty.previous();
      });
      next.addEventListener('click', (e) => {
        next.blur();
        flkty.next();
      });
    }
  }
}


// Initialize the slider on the front end
documentReady((event) => {
  var sliders = document.querySelectorAll('.slider_block');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
});


// Initialize dynamic block preview (editor).
if( window.acf ) {
  window.acf.addAction( 'render_block_preview/type=slider', initializeBlock );
}
